import { InjectionToken } from "@angular/core";
import { HttpListService } from "./services/http-list.service";

export const SOFTLINE_STORE_HTTP_OBJECT_SERVICE = new InjectionToken<HttpListService>('SOFTLINE_STORE_HTTP_OBJECT_SERVICE');
export const SOFTLINE_CONFIG_MIGEL_SUPPLIER_CONTEXT_MAX_SELECT_AMOUNT = new InjectionToken<number>('SOFTLINE_CONFIG_MIGEL_SUPPLIER_CONTEXT_MAX_SELECT_AMOUNT');
export const SOFTLINE_FEATURE_CONTENT = 'content';
export const SOFTLINE_CONST_DYNAMIC_ACTION_DOWNLOAD = 'onDownload';
export const SOFTLINE_CONST_DYNAMIC_ACTION_NAVIGATE = 'onNavigate';
